import { useState } from 'react';
import { BedDouble } from 'lucide-react';
import { PERMISSIONS, usePermissions, useTranslation } from '@bms/common';
import { Button } from '@/components/ui/button';
import { CheckInDialog } from '@/components/checkin/CheckInDialog';
import { useFlavour } from '@/providers/FlavourProvider';
import { usesGrmsDashboard } from '@/flavours';

/**
 * The shell header's **Check in guest** (plan-receptionistDesk F1): the guided
 * walk-in check-in — ready-room picker, name, nights, keys — from any page, so
 * a guest at the counter never waits for the desk to find a room card first.
 * Shown on a hotel site to a projection holding `grms:write` (the check-in
 * writes `PATCH …/occupancy`).
 */
export function CheckInGuestButton() {
  const { t } = useTranslation();
  const { flavour } = useFlavour();
  const canWriteStay = usePermissions().has(PERMISSIONS.GRMS_WRITE);
  const [open, setOpen] = useState(false);

  if (!canWriteStay || !usesGrmsDashboard(flavour)) return null;

  return (
    <>
      <Button
        size="sm"
        className="h-8 gap-1.5 px-2.5"
        aria-label={t('grms.desk.checkInGuest')}
        title={t('grms.desk.checkInGuest')}
        onClick={() => setOpen(true)}
      >
        <BedDouble className="h-4 w-4" aria-hidden />
        <span className="hidden sm:inline">{t('grms.desk.checkInGuest')}</span>
      </Button>
      {/* Mounted only while open: the guided check-in reads the reader and the site config. */}
      {open && <CheckInDialog open onOpenChange={setOpen} />}
    </>
  );
}
